import React, { lazy, Suspense } from "react";
import Hero from "../components/sections/Hero";

const Skills = lazy(() => import("../components/sections/Skills"));
const Project = lazy(() => import("../components/sections/Project"));
const Experience = lazy(() => import("../components/sections/Experience"));
const Footer = lazy(() => import("../components/sections/Footer"));

const Home = () => (
  <>
    <Hero />
    <Suspense fallback={null}>
      <Skills />
      <Project />
      <Experience />
      <Footer />
    </Suspense>
  </>
);

export default Home;
